
  import * as ipxRuntime$XsujZkRAyyhN5MMXdSLRppLYhjLlrg9mdExnONPpUh8 from '/opt/node_app/app/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as customProviderRuntime$FVfmZXi4s7P79SfVA5rN2b31Sk_TtdGKsuF1Z_45kh52U from '/opt/node_app/app/node_modules/.pnpm/@edco+apollo@0.1.1307_@unhead+vue@2.0.10_vue@3.5.16_typescript@5.7.2___db0@0.3.2_ioredis@5.6._xkd6n4k7txslgofk5escza2rdi/node_modules/@edco/apollo/src/providers/apolloProvider.js'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['ipx']: { provider: ipxRuntime$XsujZkRAyyhN5MMXdSLRppLYhjLlrg9mdExnONPpUh8, defaults: {} },
  ['ipx']: { provider: customProviderRuntime$FVfmZXi4s7P79SfVA5rN2b31Sk_TtdGKsuF1Z_45kh52U, defaults: undefined }
    }
  }
